import React from "react";
import Sponsorship from "./Sponsorship/Sponsorship";

export default () => (
  <Sponsorship/>
);
